export default __webpack_public_path__ + "static/media/35awards.7f791ccd.jpeg";